import React from 'react'
import { Link } from 'react-router-dom'
import { Query } from 'react-apollo'
import InfiniteScroll from 'react-infinite-scroller'
import _ from 'lodash'
import moment from 'moment'
import {
  H3, Div, P, Loading, Button,
} from 'konsys-ui'
import {
  EachNoti,
} from './styled'
import { GET_NOTI } from '../../constants/graphql/query'

export const convertModule = (moduleText) => {
  switch (moduleText) {
    case 'JOB': return 'job'
    case 'INVOICE': return 'invoice'
    case 'SHIPPINGORDER': return 'shipping-order'
    case 'FUEL': return 'fill-order'
    case 'BILL': return 'bill'
    case 'CLIENT': return 'client'
    case 'TRUCKOWNER': return 'truckowner'
    case 'TRUCK': return 'truck'
    case 'DRIVER': return 'driver'
    case 'GASSTATION': return 'gas-station'
    default: return 'not-found'
  }
}

const loadMore = (fetchMore, dataLength) => {
  fetchMore({
    variables: {
      offset: dataLength,
      limit: 10,
    },
    updateQuery: (prev, { fetchMoreResult }) => {
      if (!fetchMoreResult) return prev
      const newNotiList = {
        showAllNoti: {
          __typename: 'ShowAllNotiPayload',
          countAll: fetchMoreResult.showAllNoti.countAll,
          countUnread: fetchMoreResult.showAllNoti.countUnread,
          notiUnread: _.concat(prev.showAllNoti.notiUnread, fetchMoreResult.showAllNoti.notiUnread),
          notiAll: _.concat(prev.showAllNoti.notiAll, fetchMoreResult.showAllNoti.notiAll),
        },
      }
      return { ...newNotiList }
    },
  })
}

const NotificationPage = () => (
  <Query
    query={GET_NOTI}
    fetchPolicy='network-only'
    variables={{
      limit: 10,
    }}
  >
  {
    ({
      loading, data, error, fetchMore, refetch,
    }) => {
      if (loading && _.isEmpty(data)) return <Loading center='true' />
      if (error) return <P>เกิดข้อผิดพลาด</P>
      const notiList = data.showAllNoti.notiUnread
      return (
        <Div display='flex' flexDirection='column' margin='40px 0'>
          <Div display='flex' flexDirection='row' justifyContent='space-between'>
            <H3 bold>รายการแจ้งเตือนทั้งหมด</H3>
            <Button text='รีเซ็ตหน้า' icon='fas fa-undo' onClick={() => refetch()}/>
          </Div>
          <Div display='flex' justifyContent='flex-start' alignItems='flex-start' flexDirection='column' margin='18px 0'>
            <Div display='flex' flexDirection='row' margin='8px 0 16px'>
              <P>รายการทั้งหมด {_.isNull(data.showAllNoti.countAll) ? 0 : data.showAllNoti.countAll} รายการ&nbsp;</P>
              <P>รายการที่ไม่ได้อ่าน {_.isNull(data.showAllNoti.countUnread) ? 0 : data.showAllNoti.countUnread} รายการ</P>
            </Div>
            <InfiniteScroll
              loadMore={() => { if (!loading) loadMore(fetchMore, notiList.length) }}
              hasMore={notiList && notiList.length < data.showAllNoti.countUnread}
              loader={<Loading center='true' />}
              initialLoad={false}
              style={{ width: '100%' }}
            >
            {
              _.map(notiList, v => <Link to={`/${convertModule(v.mainModule)}/view/${_.split(_.split(_.split(v.message, '(')[1], ' ')[1], ')')[0]}`} style={{ width: '100%' }}>
                <EachNoti read={v.read} onClick={() => refetch()}>
                  <P>{v.message}</P>
                  <P>{moment(v.createdAt).format('DD/MM/YYYY')}</P>
                </EachNoti>
              </Link>)
            }
            </InfiniteScroll>
            {
              !(notiList && notiList.length < data.showAllNoti.countUnread)
              && <Div margin='16px 0 0' width='100%' display='flex' justifyContent='center'><P>ไม่พบรายการแจ้งเตือนเพิ่มเติม</P></Div>
            }
          </Div>
        </Div>
      )
    }
  }
  </Query>
)


export default NotificationPage
